module.exports = __webpack_public_path__ + "static/media/Spinner.0daa853a.gif";